export default {
  es: {
    txt: {
      headerOne: 'Mapa de las Religiones de Euskadi',
      headerThree: 'Elaborado por Ikuspegi',
      paraMain: 'En este mapa interactivo se recoge la información referida a la pluralidad religiosa de la CAE, tanto en lo referido a la adscripción religiosa de la población como a la cantidad y ubicación de lugares de culto de cada confesión (aquellas más relevantes en términos poblacionales). Para ello, en el caso de la adscripción religiosa, se ha realizado una estimación estadística partiendo de los datos ofrecidos por el Pew Research Center y el CIA Factbooks 2018, de tal forma que hemos obtenido la relación de las diferentes adscripciones religiosas en el mundo y teniendo en cuenta la procedencia de la población residente en el País Vasco, hemos aplicado los porcentajes a la población para así obtener una estimación cuantitativa, que siempre tiene que ser entendida como una aproximación a la realidad social existente. A continuación, se presentan los principales resultados generales para el conjunto de la CAE.',
      helpText: 'A continuación, se ofrece la oportunidad de poder ver los datos sobre adscripción religiosa y lugares de culto por municipio. Así, para cada uno de ellos se ofrece la información referida al peso de cada una de las confesiones religiosas en términos absolutos y también la posibilidad ver la distribución porcentual de la población de origen extranjero. Asimismo, se pueden obtener los datos de la ubicación de los principales lugares de culto de las confesiones religiosas radicadas en la CAE más relevantes.',
      helpTextExtra: 'Si se pulsa el icono de cada una de las adscripciones religiosas se podrá acceder a la página informativa del Observatorio del Pluralismo Religioso en España, en la que se detallan las principales características de cada una de estas adscripciones.',
      population: 'Población',
      populationTotal: 'Población Total',
      totalPop: 'Cifra Total [Num.]',
      origExt: 'Origen Ext.',
      origTotalExt: 'Total Origen Ext.',
      totalEuz: 'Total Euskadi',
      people: 'Personas',
      totalExt: 'Origen Ext. [%]',
      religion: 'Religión',
      cat: 'Católicos',
      catCenter: 'Parroquias',
      pro: 'Evangélicos',
      proCenter: 'Iglesias',
      ort: 'Ortodoxos',
      ortCenter: 'Iglesias',
      cri: 'Cristianos',
      criCenter: 'Otr. Iglesias',
      mus: 'Musulmanes',
      musCenter: 'Mezquitas',
      jud: 'Judíos',
      judCenter: 'Sinagogas',
      hin: 'Hinduístas',
      hinCenter: 'Templos',
      bud: 'Budistas',
      budCenter: 'Templos',
      ani: 'Animistas',
      aniCenter: 'Templos',
      otr: 'Otras Rel.',
      otrCenter: 'Otros Templos',
      tes: 'Testigos de Jehová',
      jes: 'La Iglesia de Jesucristo de los Santos de los Últimos Días',
      no: 'No Creyentes',
      magInitial: 'Mapa clickable',
      magHab: 'Habit.',
      magHabPerc: 'Habit. %',
      mag_cat: 'Católicos [Num.]',
      mag_pro: 'Protestantes [Num.]',
      mag_ort: 'Ortodoxos [Num.]',
      mag_cri: 'Otros Cristianos [Num.]',
      mag_mus: 'Musulmanes [Num.]',
      mag_jud: 'Judíos [Num.]',
      mag_hin: 'Hinduístas [Num.]',
      mag_bud: 'Budistas [Num.]',
      mag_ani: 'Animistas [Num.]',
      mag_otr: 'Otras [Num.]',
      mag_no: 'No Creyentes [Num.]',
      mag_perc_cat: 'Católicos [% Origen Ext.]',
      mag_perc_pro: 'Protestantes [% Origen Ext.]',
      mag_perc_ort: 'Ortodoxos [% Origen Ext.]',
      mag_perc_cri: 'Otros Cristianos [% Origen Ext.]',
      mag_perc_mus: 'Musulmanes [% Origen Ext.]',
      mag_perc_jud: 'Judíos [% Origen Ext.]',
      mag_perc_hin: 'Hinduístas [% Origen Ext.]',
      mag_perc_bud: 'Budistas [% Origen Ext.]',
      mag_perc_ani: 'Animistas [% Origen Ext.]',
      mag_perc_otr: 'Otras [% Origen Ext.]',
      mag_perc_no: 'No Creyentes [% Origen Ext.]',
      tooltipAbs: 'Población total de practicantes',
      tooltipPerc: 'Porcentaje de practicantes respecto a orig. extranjero',
      catTooltipAbs: 'Población total de católicos',
      catTooltipPerc: 'Porcentaje de católicos respecto a orig. extranjero',
      proTooltipAbs: 'Población total de evangélicos',
      proTooltipPerc: 'Porcentaje de evangélicos respecto a orig. extranjero',
      ortTooltipAbs: 'Población total de ortodoxos',
      ortTooltipPerc: 'Porcentaje de ortodoxos respecto a orig. extranjero',
      musTooltipAbs: 'Población total de musulmanes',
      musTooltipPerc: 'Porcentaje de musulmanes respecto a orig. extranjero',
      judTooltipAbs: 'Población total de judíos',
      judTooltipPerc: 'Porcentaje de judíos respecto a orig. extranjero',
      hinTooltipAbs: 'Población total de hinduístas',
      hinTooltipPerc: 'Porcentaje de hinduístas respecto a orig. extranjero',
      budTooltipAbs: 'Población total de budístas',
      budTooltipPerc: 'Porcentaje de budístas respecto a orig. extranjero',
      otrTooltipAbs: 'Población total de otras Rel.',
      otrTooltipPerc: 'Porcentaje de otras Rel. respecto a orig. extranjero',
      noTooltipAbs: 'Población total de no creyentes',
      noTooltipPerc: 'Porcentaje de no creyentes respecto a orig. extranjero',
      showMap: 'ver mapa',
      tableCaption: 'Estimación del peso de los diferentes credos religiosos en Euskadi.',
      centersMuni: 'Centros por Municipio',
      openUrltext: 'Definición [ES]',
    },
  },
  eu: {
    txt: {
      headerOne: 'Euskadiko Erlijioen Mapa',
      headerThree: 'Ikuspegitik prestatua',
      paraMain: 'Mapa interaktibo horretan, EAEko erlijio-aniztasunari buruzko informazioa jasotzen da, bai herriaren erlijio-atxikipenari dagokionez, bai konfesio bakoitzaren kultu-lekuen kantitateari eta kokapenari dagokienez (biztanleria-mugetan garrantzitsuenak direnak). Horretarako, atxikipen erlijiosoaren kasuan, kalkulu estatikoa egin da, Pew Research Centerrek eta CIA Factbooks 2018k emandako datuetatik abiatuta, eta, horrela, munduko atxikipen erlijiosoen zerrenda lortu dugu, eta Euskal Autonomia Erkidegoan bizi den populazioaren jatorria kontuan hartuta, ehunekoak aplikatu ditugu. Gizarte-errealitaterako hurbilketa gisa Ondoren, EAEko emaitza orokor nagusiak aurkezten dira.',
      helpText: 'Jarraian, erlijio-atxikipenari eta kultu-lekuei buruzko datuak udalerrika ikusteko aukera eskaintzen da. Era berean, erlijio-konfesio bakoitzak maila absolutuetan duen pisuari buruzko informazioa ematen da horietako bakoitzerako, eta atzerriko jatorriko biztanleriaren portzentajezko banaketa ikusteko aukera ere ematen da. Era berean, kaperan kokatutako erlijio-konfesio garrantzitsuenen kultu-leku nagusien kokapenari buruzko datuak lor daitezke.',
      helpTextExtra: 'Erlijio-atxikipen bakoitzaren ikonoa sakatuz gero, Erlijio Aniztasunaren Behatokiaren informazio-orrira jo ahal izango da. Bertan, atxikipen bakoitzaren ezaugarri nagusiak zehaztuko dira.',
      population: 'Biztanleria',
      populationTotal: 'Biztanleria Guztira',
      totalPop: 'Guztira [Zbk.]',
      origExt: 'Atz. Jatorria',
      origTotalExt: 'Atzerriko Jatorria Guztira',
      totalEuz: 'Euskadi Guztira',
      people: 'Pertsona',
      totalExt: 'Atz. Jatorria [%]',
      religion: 'Erlijioa',
      cat: 'Katolikoen',
      catCenter: 'Parrokiak',
      pro: 'Ebangelikoak',
      proCenter: 'Elizak',
      ort: 'Ortodoxoak',
      ortCenter: 'Elizak',
      cri: 'Kristauak',
      criCenter: 'Bes. Elizak',
      mus: 'Musulmanak',
      musCenter: 'Meskitak',
      jud: 'Juduak',
      judCenter: 'Sinagogak',
      hin: 'Hinduistak',
      hinCenter: 'Tenpluak',
      bud: 'Budistak',
      budCenter: 'Tenpluak',
      ani: 'Animistak',
      aniCenter: 'Tenpluak',
      otr: 'Beste erlijio',
      otrCenter: 'Beste Tenpluak',
      tes: 'Jehobaren lekukoak',
      jes: 'Azken egunetako Santuen Jesukristoren Eliza',
      no: 'Sinesgabeak',
      magInitial: 'Mapa klikagarria',
      magHab: 'Jende',
      magHabPerc: 'Jende %',
      mag_cat: 'Katolikoak [Zbk.]',
      mag_pro: 'Protestanteak [Zbk.]',
      mag_ort: 'Ortodoxoak [Zbk.]',
      mag_cri: 'Beste Kristauak [Zbk.]',
      mag_mus: 'Musulmanak [Zbk.]',
      mag_jud: 'Juduak [Zbk.]',
      mag_hin: 'Hinduistak [Zbk.]',
      mag_bud: 'Budistak [Zbk.]',
      mag_ani: 'Animistak [Zbk.]',
      mag_otr: 'Besteak [Zbk.]',
      mag_no: 'Sinesgabeak [Zbk.]',
      mag_perc_cat: 'Katolikoak [% Atz. Jatorria]',
      mag_perc_pro: 'Protestanteak [% Atz. Jatorria]',
      mag_perc_ort: 'Ortodoxoak [% Atz. Jatorria]',
      mag_perc_cri: 'Beste Kristauak [% Atz. Jatorria]',
      mag_perc_mus: 'Musulmanes [% Atz. Jatorria]',
      mag_perc_jud: 'Juduak [% Atz. Jatorria]',
      mag_perc_hin: 'Hinduistak [% Atz. Jatorria]',
      mag_perc_bud: 'Budistak [% Atz. Jatorria]',
      mag_perc_ani: 'Animistak [% Atz. Jatorria]',
      mag_perc_otr: 'Besteak [% Atz. Jatorria]',
      mag_perc_no: 'Sinesgabeak [% Atz. Jatorria]',
      tooltipAbs: 'Praktikatzaileen biztanleria, guztira',
      tooltipPerc: 'Praktikatzaileen ehunekoa atzerriko jatorriarekiko',
      catTooltipAbs: 'Katolikoen populazio osoa',
      catTooltipPerc: 'Katolikoen ehunekoa atzerriko jatorriarekiko',
      proTooltipAbs: 'Ebanjelikoen populazioa, guztira',
      proTooltipPerc: 'Ebanjelikoen ehunekoa atzerriko jatorriarekiko',
      ortTooltipAbs: 'Ortodoxoen populazio osoa',
      ortTooltipPerc: 'Ortodoxoen ehunekoa atzerriko jatorriarekiko',
      musTooltipAbs: 'Musulmanen populazio osoa',
      musTooltipPerc: 'Musulmanen ehunekoa atzerriko jatorriarekiko',
      judTooltipAbs: 'Juduen populazio osoa',
      judTooltipPerc: 'Juduen ehunekoa atzerriko jatorriarekiko',
      hinTooltipAbs: 'Hinduisten populazio osoa',
      hinTooltipPerc: 'Hinduisten ehunekoa atzerriko jatorriarekiko',
      budTooltipAbs: 'Budisten populazioa, guztira',
      budTooltipPerc: 'Budisten ehunekoa atzerriko jatorriarekiko',
      otrTooltipAbs: 'Beste Erl. batzuetako biztanleria, guztira',
      otrTooltipPerc: 'Atzerriko jatorriarekiko beste Erl. batzuen ehunekoa',
      noTooltipAbs: 'Ez sinestunen biztanleria osoa',
      noTooltipPerc: 'Fededun ez direnen ehunekoa atzerriko jatorriarekiko',
      showMap: 'mapa ikusi',
      tableCaption: 'Euskadiko erlijio-sinesmen desberdinen pisua zenbatestea.',
      centersMuni: 'Centros por Municipio',
      openUrltext: 'Definizioa [ES]',
    },
  },
  en: {
    txt: {
      headerOne: 'Map of the Religions of the Basque Country',
      headerThree: 'Elaborated by Ikuspegi',
      paraMain: 'In this interactive map the information referring to the religious plurality of the CAE is collected, both in terms of the religious ascription of the population and the amount and location of places of worship of each confession (those most relevant in population terms). For this, in the case of religious ascription, a statistical estimate has been made based on the data offered by the Pew Research Center and the CIA Factbooks 2018, so that we have obtained the relationship of the different religious ascriptions in the world and taking into account the origin of the population residing in the Basque Country, we have applied the percentages to the population in order to obtain a quantitative estimate, which always has to be understood as an approximation to the existing social reality. The main general results for the whole of the CAE are presented below.',
      helpText: 'Next, there is the opportunity to see the data on religious ascription and places of worship by municipality. Thus, for each one of them, the information referring to the weight of each one of the religious denominations is offered in absolute terms and also the possibility to see the percentage distribution of the population of foreign origin. Likewise, the location data of the main places of worship of the most relevant religious confessions in the CAE can be obtained.',
      helpTextExtra: 'If the icon of each of the religious ascriptions is pressed, the informative page of the Observatory of Religious Pluralism in Spain can be accessed, in which the main characteristics of each of these ascriptions are detailed.',
      population: 'Population',
      populationTotal: 'Total Population',
      totalPop: 'Total figure [Num.]',
      origExt: 'Foreign Orig.',
      origTotalExt: 'Total Foreign Origin',
      totalEuz: 'Euskadi Total',
      people: 'People',
      totalExt: 'Foreign Orig. [%]',
      religion: 'Religion',
      cat: 'Catholics',
      catCenter: 'Parishes',
      pro: 'Evangelicals',
      proCenter: 'Churches',
      ort: 'Orthodoxes',
      ortCenter: 'Churches',
      cri: 'Christians',
      criCenter: 'Oth. Churches',
      mus: 'Muslims',
      musCenter: 'Mosques',
      jud: 'Jews',
      judCenter: 'Synagogues',
      hin: 'Hindus',
      hinCenter: 'Temples',
      bud: 'Budists',
      budCenter: 'Temples',
      ani: 'Animists',
      aniCenter: 'Temples',
      otr: 'Other Rel.',
      otrCenter: 'Other Temples',
      tes: 'Jehovah´s Witnesses',
      jes: 'The Church of Jesus Christ of Latter-day Saints',
      no: 'Not Believers',
      magInitial: 'Clickable Map',
      magHab: 'Populat.',
      magHabPerc: 'Populat. %',
      mag_cat: 'Catholics [Num.]',
      mag_pro: 'Evangelicals [Num.]',
      mag_ort: 'Orthodoxes [Num.]',
      mag_cri: 'Other Christians [Num.]',
      mag_mus: 'Muslims [Num.]',
      mag_jud: 'Jews [Num.]',
      mag_hin: 'Hindus [Num.]',
      mag_bud: 'Budists [Num.]',
      mag_ani: 'Animists [Num.]',
      mag_otr: 'Other [Num.]',
      mag_no: 'Not Believers [Num.]',
      mag_perc_cat: 'Catholics [% Foreign Orig.]',
      mag_perc_pro: 'Evangelicals [% Foreign Orig.]',
      mag_perc_ort: 'Orthodoxes [% Foreign Orig.]',
      mag_perc_cri: 'Other Christians [% Foreign Orig.]',
      mag_perc_mus: 'Muslims [% Foreign Orig.]',
      mag_perc_jud: 'Jews [% Foreign Orig.]',
      mag_perc_hin: 'Hindus [% Foreign Orig.]',
      mag_perc_bud: 'Budists [% Foreign Orig.]',
      mag_perc_ani: 'Animists [% Foreign Orig.]',
      mag_perc_otr: 'Other [% Foreign Orig.]',
      mag_perc_no: 'Not Believers [% Foreign Orig.]',
      tooltipAbs: 'Total population of practitioners',
      tooltipPerc: 'Percentage of practitioners regarding foreign origin',
      catTooltipAbs: 'Total population of catholics',
      catTooltipPerc: 'Percentage of catholics regarding orig. Foreign',
      proTooltipAbs: 'Total population of evangelicals',
      proTooltipPerc: 'Percentage of evangelicals regarding foreign origin',
      ortTooltipAbs: 'Total orthodox population',
      ortTooltipPerc: 'Percentage of orthodox regarding foreign origin',
      musTooltipAbs: 'Total population of muslims',
      musTooltipPerc: 'Percentage of muslims regarding foreign origin',
      judTooltipAbs: 'Total population of jews',
      judTooltipPerc: 'Percentage of jews regarding foreign origin',
      hinTooltipAbs: 'Total Hindu population',
      hinTooltipPerc: 'Percentage of Hinduists regarding foreign origin',
      budTooltipAbs: 'Total population of buddhists',
      budTooltipPerc: 'Percentage of buddhists with respect to foreign origin',
      otrTooltipAbs: 'Total population of other religions',
      otrTooltipPerc: 'Percentage of other religions regarding foreign origin',
      noTooltipAbs: 'Total population of non-believers',
      noTooltipPerc: 'Percentage of non-believers regarding foreign origin',
      showMap: 'show map',
      tableCaption: 'Estimation of the weight of the different religious creeds in Euskadi.',
      centersMuni: 'Centros por Municipio',
      openUrltext: 'Definition [ES]',
    },
  },
  fr: {
    txt: {
      headerOne: 'Carte des Religions du Pays Basque',
      headerThree: 'Elaboré par Ikuspegi',
      paraMain: 'Sur cette carte interactive, les informations relatives à la pluralité religieuse des CAE sont collectées, tant en termes d´attribution religieuse de la population que de quantité et de localisation des lieux de culte de chaque confession (les plus pertinentes en termes de population). Pour cela, dans le cas de l´attribution religieuse, une estimation statistique a été faite sur la base des données proposées par le Pew Research Center et les CIA Factbooks 2018, de sorte que nous avons obtenu la relation des différentes attributions religieuses dans le monde et en tenant compte de l´origine de la population résidant au Pays basque, nous avons appliqué les pourcentages à la population afin d´obtenir une estimation quantitative, qui doit toujours être comprise comme une approximation de la réalité sociale existante. Les principaux résultats généraux pour l´ensemble du CAE sont présentés ci-dessous.',
      helpText: 'Ensuite, il y a la possibilité de voir les données sur l´attribution religieuse et les lieux de culte par municipalité. Ainsi, pour chacune d´elles, les informations se référant au poids de chacune des confessions religieuses sont offertes en termes absolus ainsi que la possibilité de voir la répartition en pourcentage de la population d´origine étrangère. De même, les données de localisation des principaux lieux de culte des confessions religieuses les plus pertinentes du CAE peuvent être obtenues.',
      helpTextExtra: 'Si vous appuyez sur l´icône de chacune des attributions religieuses, la page informative de l´Observatoire du pluralisme religieux en Espagne est accessible, détaillant les principales caractéristiques de chacune de ces attributions.',
      population: 'Population',
      populationTotal: 'Population totale',
      totalPop: 'Total chiffre [Num.]',
      origExt: 'Orig. étrangère',
      origTotalExt: 'Origine Étrangère Totale',
      totalEuz: 'Total Euskadi',
      people: 'People',
      totalExt: 'Origine étrangère. [%]',
      religion: 'Religion',
      cat: 'Catholiques',
      catCenter: 'Paroisse [Num.]',
      pro: 'Evangelicals',
      proCenter: 'Eglises [Num.]',
      ort: 'Orthodoxes',
      ortCenter: 'Eglises [Num.]',
      cri: 'Chrétiens',
      criCenter: 'Autr. Églises [Num.]',
      mus: 'Musulmans',
      musCenter: 'Mosquées [Num.]',
      jud: 'Juifs',
      judCenter: 'Synagogues [Num.]',
      hin: 'Hindous',
      hinCenter: 'Temples [Num.]',
      bud: 'Budists',
      budCenter: 'Temples [Num.]',
      ani: 'Animistes',
      aniCenter: 'Temples [Num.]',
      otr: 'Autre Rel.',
      otrCenter: 'Les Témoins de Jéhovah',
      tes: 'Les Témoins de Jéhovah',
      jes: 'L´Église de Jésus-Christ des Saints des Derniers Jours',
      no: 'Pas les croyants',
      magInitial: 'Carte cliquable',
      magHab: 'Populat.',
      magHabPerc: 'Populat %',
      mag_cat: 'Catholiques [Num.]',
      mag_pro: 'Evangelicals [Num.]',
      mag_ort: 'Orthodoxes [Num.]',
      mag_cri: 'Autres Chrétiens [Num.]',
      mag_mus: 'Musulmans [Num.]',
      mag_jud: 'Juifs [Num.]',
      mag_hin: 'Hindous [Num.] ',
      mag_bud: 'Budists [Num.]',
      mag_ani: 'Animistes [Num.] ',
      mag_otr: 'Autre [Num.]',
      mag_no: 'Pas de croyants [Num.]',
      mag_perc_cat: 'Catholiques [% Orig. étrangère]',
      mag_perc_pro: 'Evangelicals [% Orig. étrangère]',
      mag_perc_ort: 'Orthodoxes [% Orig. étrangère]',
      mag_perc_cri: 'Autres Chrétiens [% Orig. étrangère]',
      mag_perc_mus: 'Musulmans [% Orig. étrangère]',
      mag_perc_jud: 'Juifs [% Orig. étrangère]',
      mag_perc_hin: 'Hindous [% Orig. étrangère]',
      mag_perc_bud: 'Budists [% Orig. étrangère]',
      mag_perc_ani: 'Animistes [% Orig. étrangère]',
      mag_perc_otr: 'Autre [% Orig. étrangère]',
      mag_perc_no: 'Pas de croyants [% Orig. étrangère]',
      tooltipAbs: 'Population totale de praticiens',
      tooltipPerc: 'Pourcentage de praticiens par rapport à l´origine étrangère',
      catTooltipAbs: 'Population totale de catholiques',
      catTooltipPerc: 'Pourcentage de catholiques d´origine étrangère',
      proTooltipAbs: 'Population totale des évangéliques',
      proTooltipPerc: 'Pourcentage de évangéliques d´origine étrangère',
      ortTooltipAbs: 'Population orthodoxe totale',
      ortTooltipPerc: 'Pourcentage de orthodoxes d´origine étrangère',
      musTooltipAbs: 'Population totale de musulmans',
      musTooltipPerc: 'Pourcentage de musulmans d´origine étrangère',
      judTooltipAbs: 'Population totale de juifs',
      judTooltipPerc: 'Pourcentage de Juifs d´origine étrangère',
      hinTooltipAbs: 'Population hindoue totale',
      hinTooltipPerc: 'Pourcentage de hindouistes d´origine étrangère',
      budTooltipAbs: 'Population totale de bouddhistes',
      budTooltipPerc: 'Pourcentage de bouddhistes d´origine étrangère',
      otrTooltipAbs: 'Population totale des autres religions',
      otrTooltipPerc: 'Pourcentage des autres religions d´origine étrangère',
      noTooltipAbs: 'Population totale des non-croyants',
      noTooltipPerc: 'Pourcentage de non-croyants d´origine étrangère',
      showMap: 'voir plan',
      tableCaption: 'Estimation du poids des différentes croyances religieuses en Euskadi.',
      centersMuni: 'Centros por Municipio',
      openUrltext: 'Définition [ES]',
    },
  },
}
